import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTokens } from '@mcn-platform/models';
const PrevNext = ({ hasNext, hasPrev, goNext, goPrev, isMobileView, }) => {
    const tokens = useTokens();
    const iconStyle = (t, disabled) => ({
        width: { md: '25px' },
        height: { md: '25px' },
        strokeWidth: '1.5',
        color: disabled ? 'grey' : t.portal.courseDeliveryPage.lessonTitle.font.color,
    });
    return (_jsxs(Stack, { spacing: 0.5, direction: "row", sx: { mt: { md: '-8px', xs: '0px' } }, children: [_jsx(Box, { children: _jsxs(Button, { disabled: !hasPrev, onClick: goPrev, sx: {
                        px: { xs: !isMobileView ? '0' : '', md: 2 },
                        minWidth: !isMobileView ? 'auto' : '',
                    }, children: [_jsx(ArrowBackIcon, { sx: (t) => ({
                                ...iconStyle(t, !hasPrev),
                                mr: { md: 1, xs: !isMobileView ? '0' : '' },
                            }) }), !isMobileView && (_jsx(Typography, { variant: "caption", className: "lessonTitle", children: tokens.getToken('prevLabel') }))] }) }), _jsx(Box, { children: _jsxs(Button, { disabled: !hasNext, onClick: goNext, sx: {
                        px: { xs: !isMobileView ? '0' : '', md: 2 },
                        pr: { xs: '0', md: '8px' },
                        minWidth: !isMobileView ? 'auto' : '',
                    }, children: [!isMobileView && (_jsx(Typography, { variant: "caption", className: "lessonTitle", children: tokens.getToken('nextLabel') })), _jsx(ArrowForwardIcon, { sx: (t) => ({
                                ...iconStyle(t, !hasNext),
                                ml: !isMobileView ? '0' : '',
                            }) })] }) })] }));
};
export default PrevNext;
//# sourceMappingURL=PrevNext.js.map